import { useEffect, useState } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

export const GoogleMapsReadyGate = ({ children, fallback = null, requireMarker = false }) => {
  const mapsLibrary = useMapsLibrary('maps');
  const markerLibrary = useMapsLibrary('marker');
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!mapsLibrary?.Map) {
      setIsReady(false);
      return;
    }

    try {
      if (typeof window !== 'undefined' && window.google?.maps && typeof window.google.maps.Map !== 'function') {
        window.google.maps.Map = mapsLibrary.Map;
      }

      if (
        requireMarker &&
        markerLibrary?.AdvancedMarkerElement &&
        window.google?.maps?.marker &&
        typeof window.google.maps.marker.AdvancedMarkerElement !== 'function'
      ) {
        window.google.maps.marker.AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;
      }
    } catch (_) {
      // If Google marks a constructor as read-only, keep waiting for the global API to settle.
    }

    const mapConstructorReady =
      typeof window !== 'undefined' &&
      typeof window.google?.maps?.Map === 'function';
    const markerConstructorReady =
      !requireMarker ||
      (
        typeof window !== 'undefined' &&
        typeof window.google?.maps?.marker?.AdvancedMarkerElement === 'function'
      );

    setIsReady(mapConstructorReady && markerConstructorReady);
  }, [mapsLibrary, markerLibrary, requireMarker]);

  return isReady ? children : fallback;
};

export default GoogleMapsReadyGate;
